<template>
  <div>
    <div class="loading-spinner-outer" v-if="saving">
      <div class="loading-spinner-inner">
        <div class="loading-spinner"></div>
        <div class="loading-spinner-content">
          Saving, please wait
        </div>
      </div>
    </div>
    <div class="box">
      <div class="box-content">
        <div class="form-group">
          <label> Areas this company supplies to: </label>
          <label v-if="postcode_areas_for_company_updated_at_date !== ''">Last updated by: {{ postcode_areas_for_company_updated_by_name }} - {{ postcode_areas_for_company_updated_at_date }}</label>
          <div class="checkboxes" style="display: flex; flex-wrap: wrap; flex-direction: row;">
            <label class="checkbox" v-for="postcode_prefix in postcode_prefixes" style="width: 80px; padding: 5px;">
              <input type="checkbox" v-model="postcode_areas_for_company" :value="postcode_prefix.id">
              <span class="checkbox-label"> {{ postcode_prefix.postcode_prefix }} </span>
            </label>
          </div>
        </div>
        <div class="align-right">
          <a class="btn-primary" @click.prevent="save()">Save</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
        company_id: {
            required: true,
        },
        logged_in_user: {
            required: true,
        },
        postcode_prefixes: {
            required: true,
        },
        selected_postcodes: {
            required: true,
        },
        postcode_areas_for_company_updated_at_date: {
            required: false,
            default() {
                return '';
            },
        },
        postcode_areas_for_company_updated_by_name: {
            required: false,
            default() {
                return null;
            },
        },
    },
    data() {
      return {
        saving: false,
        postcode_areas_for_company: [],
      }
    },
    mounted() {
      this.postcode_areas_for_company = this.selected_postcodes;
    },
    methods: {
      save() {
        this.saving = true;
        axios.post('/company/update-postcode-areas', {
          company_id: this.company_id,
          selected_postcodes: this.postcode_areas_for_company,
        }).then(() => {
          Swal.fire({
            title: 'Areas Updated',
            icon: 'success',
          });
          this.saving = false;
          window.location.reload();
        });
      },
    },
  };
</script>
